export const dataHostInfo = {
  type: 'object',
  required: ['HostDeviceID', 'HostDeviceModel', 'HostVersion'],
  properties: {
    HostDeviceID: {
      type: 'string',
      minLength: 1,
    },
    HostDeviceModel: {
      type: 'string',
      minLength: 1,
    },
    HostVersion: {
      type: 'string',
      minLength: 1,
    },
  },
};
